<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 报警预警 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <el-header class="header-id">
          <!-- margin-left:20px; -->
          <span style="font-size: 15px">预警类型：</span>
          <el-select v-model="listQuery.alert_type" multiple collapse-tags filterable placeholder="请选择" style="margin-right: 20px; width: 250px">
            <el-option v-for="item in earlyWarningOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
          <span style="font-size: 15px; margin-left: 10px">预警通知人：</span>
          <el-select v-model="listQuery.base_admin_list" multiple collapse-tags filterable placeholder="请选择" style="margin-right: 20px; width: 250px">
            <el-option v-for="item in noticePersonOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
          <span style="font-size: 15px; margin-left: 10px">特殊类型名称：</span>
          <el-select v-model="listQuery.special_type" multiple collapse-tags filterable placeholder="请选择" style="margin-right: 20px">
            <el-option v-for="item in specialTypeOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
          <span style="font-size: 15px; margin-left: 10px">通知类型：</span>
          <el-select v-model="listQuery.alert_method" filterable placeholder="请选择" style="margin-right: 20px">
            <el-option v-for="item in noticeOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
          <span style="font-size: 15px; margin-left: 10px">开关：</span>
          <el-select v-model="listQuery.system_status" filterable placeholder="请选择" style="margin-right: 20px">
            <el-option v-for="item in switchOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
          <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button class="filter-item" type="warning" @click="handleReset">重置</el-button>
          <el-button class="filter-item" type="success" @click="handleAdd" v-if="store_button">添加</el-button>
        </el-header>

        <el-main>
          <tablePagination
            :tableData="tableData"
            :tableColumn="tableColumn"
            :listLoading="listLoading"
            :total="total"
            :listQuery="listQuery"
            :switchName="switchName"
            @getList="handleList"
            @switchControl="switchControl"
            @viewDetails="viewDetails"
            @fixWarning="fixWarning"
            @delleteWarning="delleteWarning"
            :update_button="update_button"
            :destroy_button="destroy_button"
          />

          <el-dialog title="删除" width="40%" :visible.sync="deleteShow">
            <p style="text-align: center">确认删除吗？</p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="deleteShow = false">取 消</el-button>
              <el-button type="primary" @click="sureDelete">确认</el-button>
            </div>
          </el-dialog>

          <el-dialog :title="titleName" width="60%" center :visible.sync="addshow" :close-on-click-modal="closeControl" @close="closeDialog">
            <warningForm
              :formData="formData"
              :earlyWarningOptions="earlyWarningOptions"
              :specialTypeOptions="specialTypeOptions"
              :noticePersonOptions="noticePersonOptions"
              :phoneNoticeOptions="phoneNoticeOptions"
              :switchOptions="switchOptions"
              :phoneNoticePersonOptions="phoneNoticePersonOptions"
              :boundaryName="boundaryName"
              :idDisabled="idDisabled"
              :dingShow="dingShow"
              :phoneShow="phoneShow"
              :viewShow="!idDisabled"
              :specialShow="specialShow"
            >
            </warningForm>
            <div slot="footer" class="dialog-footer">
              <el-button @click="remove">取 消</el-button>
              <el-button type="primary" @click="sure" v-if="!idDisabled">确认</el-button>
            </div>
          </el-dialog>
        </el-main>
      </div>
    </div>
  </div>
</template>

<script>
import { warningListApi, warningAddApi, warningViewApi, warningFixApi, warningDeleteApi, warningSwitchApi, getSelectListApi } from '@/api/early_warning';
import tablePagination from '@/components/page/configureSummary/early_warning/tablePagination';
import warningForm from '@/components/page/configureSummary/early_warning/warningForm';

export default {
  components: { tablePagination, warningForm },
  name: 'early_warning',
  computed: {
    dingShow() {
      let m = false;
      if (this.formData.alert_method.indexOf('弹窗') != '-1') {
        m = true;
      }
      return m;
    },
    specialShow() {
      let show = false;
      if (this.formData.alert_type == 2) {
        show = true;
      }
      return show;
    },
    phoneShow() {
      let m = false;
      if (this.formData.alert_by_phone == 1 && this.formData.alert_method.indexOf('弹窗') != '-1') {
        m = true;
      }
      return m;
    },
    idDisabled() {
      let m = false;
      if (this.titleName == '查看详情') {
        m = true;
      }
      return m;
    },
    closeControl() {
      let m = true;
      if (this.titleName == '添加') {
        m = false;
      }
      return m;
    },
  },
  data() {
    return {
      listLoading: false,
      total: 0,
      tableData: [],
      tableColumn: [
        {
          prop: 'alert_type_text',
          label: '预警类型',
        },
        {
          prop: 'special_type_text',
          label: '特殊类型',
        },
        {
          prop: 'time_interval_text',
          label: '时间间隔',
        },
        {
          prop: 'range_time',
          label: '监控范围',
        },
        {
          prop: 'alert_value',
          label: '阈值',
        },
        {
          prop: 'base_admin_text',
          label: '预警通知人',
        },
        {
          prop: 'phone_status_text',
          label: '电话通知',
        },
        {
          prop: 'phone_admin_text',
          label: '电话通知人',
        },
        {
          prop: 'alert_method_text',
          label: '通知类型',
        },
        {
          prop: 'system_status_text',
          label: '状态',
        },
      ],
      listQuery: {
        page: 1,
        limit: 10,
        alert_type: [],
        special_type: [],
        base_admin_list: [],
        alert_method: '',
        system_status: '',
      },
      gameNameOptions: [],
      specialTypeOptions: [],
      noticeOptions: [],
      switchOptions: [],
      earlyWarningOptions: [],
      noticePersonOptions: [],
      phoneNoticeOptions: [
        {
          name: '开启',
          id: 1,
        },
        {
          name: '关闭',
          id: 0,
        },
      ],
      phoneNoticePersonOptions: [],
      formData: {
        alert_type: '',
        special_type: [],
        time_interval_value: '',
        time_interval_type: '',
        alert_value: '',
        timeRange: [],
        base_alert_admin: [],
        alert_method: [],
        alert_by_phone: '',
        phone_alert_value: '',
        system_status: '',
      },
      boundaryName: '阈值：',
      titleName: '',
      switchName: '开启',
      addshow: false,
      formInputWidth: '200px',
      value1: undefined,
      deleteShow: false,
      delID: '',
      // 添加数据的缓存。
      addData: {},
      addCheck: 0,

      // 按钮权限
      store_button: false,
      update_button: false,
      destroy_button: false,
    };
  },
  created() {
    this.handleList();
    this.initialize();
  },
  methods: {
    initialize() {
      getSelectListApi()
        .then((response) => {
          this.earlyWarningOptions = response.data.data.alert_type;
          this.specialTypeOptions = response.data.data.special_type;
          this.noticeOptions = response.data.data.alert_method;
          this.switchOptions = response.data.data.system_status;
          this.noticePersonOptions = response.data.data.admin;
          this.phoneNoticePersonOptions = response.data.data.admin;
        })
        .catch((error) => {});
    },
    handleSearch() {
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      this.handleList();
    },
    handleReset() {
      for (let key in this.listQuery) {
        this.listQuery[key] = '';
      }
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      this.listQuery.alert_type = [];
      this.listQuery.special_type = [];
      this.listQuery.base_admin_list = [];
      this.handleList();
    },
    handleList() {
      this.listLoading = true;
      warningListApi(this.listQuery)
        .then((response) => {
          this.tableData = response.data.data.data.map((item) => {
            item.range_time = item.begin_time + ' - ' + item.end_time;
            return item;
          });
          this.total = response.data.data.total;
          this.store_button = response.data.data.store_button;
          this.update_button = response.data.data.update_button;
          this.destroy_button = response.data.data.destroy_button;
          this.listLoading = false;
        })
        .catch((error) => {
          this.listLoading = false;
        });
    },
    handleAdd() {
      this.resetFormat();
      if (this.addCheck == 1) {
        this.formData = JSON.parse(JSON.stringify(this.addData));
      }
      this.titleName = '添加';
      this.addshow = true;
    },
    resetFormat() {
      for (let key in this.formData) {
        this.formData[key] = '';
      }
      this.formData.timeRange = ['00:00', '23:00'];
      this.formData.special_type = [];
      this.formData.alert_method = [];
    },
    time() {
      if (!this.value1) return;
      this.listQuery.census_date_start = this.value1[0];
      this.listQuery.census_date_end = this.value1[1];
    },
    remove() {
      this.addshow = false;
    },
    sure() {
      console.log(this.formData.base_alert_admin);
      let data = JSON.parse(JSON.stringify(this.formData));
      console.log(data);
      if (this.formData.alert_type != 2) {
        data.special_type = [];
      }
      if (this.formData.alert_method.indexOf('弹窗') == '-1') {
        data.alert_by_phone = '';
      }
      if (data.alert_by_phone != 1) {
        data.phone_alert_value = '';
        data.phone_alert_admin = [];
      }
      if (this.formData.timeRange.length != 0) {
        data.begin_time = this.formData.timeRange[0];
        data.end_time = this.formData.timeRange[1];
      } else {
        data.begin_time = data.end_time = '';
      }
      if (this.formData.alert_method.length == 2) {
        data.alert_method = 3;
        if (this.formData.alert_by_phone === '') {
          this.$message.error('请选择是否开启电话通知');
          return;
        }
      } else if (this.formData.alert_method.length == 1) {
        if (this.formData.alert_method == '弹窗') {
          data.alert_method = 1;
          if (this.formData.alert_by_phone === '') {
            this.$message.error('请选择是否开启电话通知');
            return;
          }
        } else {
          data.alert_method = 2;
          this.$delete(data, 'alert_by_phone');
        }
      }
      this.$delete(data, 'timeRange');

      data.phone_alert_value = Number(data.phone_alert_value);
      if (this.titleName == '添加') {
        warningAddApi(data)
          .then((response) => {
            this.$message.success('添加成功');
            this.addCheck = 2;
            this.addshow = false;
            this.handleList();
          })
          .catch((error) => {});
      } else if (this.titleName == '修改') {
        warningFixApi(data)
          .then((response) => {
            this.$message.success('添加成功');
            this.addshow = false;
            this.handleList();
          })
          .catch((error) => {});
      }
    },
    switchControl(item) {
      warningSwitchApi({ id: item.id })
        .then((response) => {
          this.handleList();
        })
        .catch((error) => {});
    },
    viewDetails(item) {
      this.resetFormat();
      this.warningView(item);
      this.titleName = '查看详情';
      this.addshow = true;
    },
    warningView(item) {
      warningViewApi({ id: item.id })
        .then((response) => {
          response.data.data.timeRange = [];
          Object.assign(this.formData, response.data.data);
          if (this.formData.alert_method == 1) {
            this.formData.alert_method = ['弹窗'];
          } else if (this.formData.alert_method == 2) {
            this.formData.alert_method = ['飞书'];
          } else if (this.formData.alert_method == 3) {
            this.formData.alert_method = ['飞书', '弹窗'];
          }
          this.formData.time_interval_type = String(this.formData.time_interval_type);
          this.formData.timeRange = [response.data.data.begin_time, response.data.data.end_time];
        })
        .catch((error) => {});
    },
    fixWarning(item) {
      console.log(this.formData);
      this.resetFormat();
      this.warningView(item);
      this.titleName = '修改';
      this.addshow = true;
    },
    delleteWarning(item) {
      this.delID = item.id;
      this.deleteShow = true;
    },
    sureDelete() {
      warningDeleteApi({ id: this.delID })
        .then((response) => {
          this.$message.success('删除成功');
          this.deleteShow = false;
          this.handleList();
        })
        .catch((error) => {});
    },
    closeDialog() {
      if (this.titleName == '添加' && (this.addCheck == 0 || this.addCheck == 1)) {
        this.addData = JSON.parse(JSON.stringify(this.formData));
        this.addCheck = 1;
      }
      if (this.titleName == '添加' && this.addCheck == 2) {
        this.addCheck = 0;
        this.addData = {};
      }
    },
  },
};
</script>

<style>
.title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 20px;
}
.header-id {
  font-size: 14px;
  height: 80px !important;
  overflow: unset;
}
</style>